import { Auth } from "@aws-amplify/auth"
import { FunctionComponent, MouseEventHandler, useContext, useState } from "react"
import Container from "react-bootstrap/Container"
import Nav from "react-bootstrap/Nav"
import Navbar from "react-bootstrap/Navbar"
import { GiHamburgerMenu } from "react-icons/gi"
import { Route, RouterProvider, createBrowserRouter, createRoutesFromElements } from "react-router-dom"
import styled from "styled-components"
import { AppContext, AppProvider } from "./components/AppContext"
import Icon from "./components/Icon"
import SideMenu from "./components/SideMenu"
import logo from "./images/logo.png"
import CancelEndPage from "./pages/CancelEndPage"
import CancelStartPage from "./pages/CancelStartPage"
import ChangeEndPage from "./pages/ChangeEndPage"
import ChangePasswordPage from "./pages/ChangePasswordPage"
import ChangePlanPage from "./pages/ChangePlanPage"
import CreateUnitRoutersPage from "./pages/CreateRoutersPage"
import HomePage from "./pages/HomePage"
import RouterPage from "./pages/RouterPage"
import RoutersPage from "./pages/RoutersPage"
import ScheduleEndPage from "./pages/ScheduleEndPage"
import ScheduleStartPage from "./pages/ScheduleStartPage"
import ScriptsPage from "./pages/ScriptsPage"
import SignInPage from "./pages/SignInPage"
import StartNowPage from "./pages/StartNowPage"
import TemplatePage from "./pages/TemplatePage"
import TemplatesPage from "./pages/TemplatesPage"

Auth.configure({
	region: "us-east-1",
	userPoolId: process.env.REACT_APP_USER_POOL_ID,
	userPoolWebClientId: process.env.REACT_APP_USER_POOL_WEB_CLIENT_ID,
	authenticationFlowType: "USER_PASSWORD_AUTH",
})

const App: FunctionComponent = () => {
	return (
		<AppProvider>
			<Menu />
			<Content />
		</AppProvider>
	)
}
export default App

interface IMenu {}
const Menu: FunctionComponent<IMenu> = () => {
	const [isSideMenuVisible, SetSideMenuVisible] = useState(false)
	const { isAuthenticated, setIsAuthenticated, setGroups } = useContext(AppContext)
	const handleSignout: MouseEventHandler = (event) => {
		event.preventDefault()
		Auth.signOut().then(() => {
			setGroups([])
			setIsAuthenticated(false)
		})
	}
	return (
		<>
			<Navbar variant="dark" bg="dark">
				<Container fluid>
					<Icon component={GiHamburgerMenu} color="#a5a5a5" hoverColor="white" onClick={() => SetSideMenuVisible(!isSideMenuVisible)} />
					<Navbar.Brand href="https://norhart.com/hero">
						<Logo src={logo} className="App-logo" alt="Hero" />
					</Navbar.Brand>
					<Nav className="justify-content-end">
						{isAuthenticated && (
							<Nav.Link href="#logout" onClick={handleSignout}>
								Sign Out
							</Nav.Link>
						)}
					</Nav>
				</Container>
			</Navbar>
			<SideMenu showNavBar={isSideMenuVisible} />
		</>
	)
}

interface IContent {}
const Content: FunctionComponent<IContent> = () => {
	const { isAuthenticated } = useContext(AppContext)
	if (!isAuthenticated) {
		return <SignInPage />
	} else {
		const router = createBrowserRouter(
			createRoutesFromElements(
				<>
					<Route path="/" element={<HomePage />} errorElement={<HomePage />} />
					<Route path="routers" element={<RoutersPage />} />
					<Route path="routers/create" element={<CreateUnitRoutersPage />} />
					<Route path="routers/:routerId" element={<RouterPage />} />
					<Route path="routers/:routerId/start-now" element={<StartNowPage />} />
					<Route path="routers/:routerId/schedule-start" element={<ScheduleStartPage />} />
					<Route path="routers/:routerId/schedule-end" element={<ScheduleEndPage />} />
					<Route path="routers/:routerId/change-end" element={<ChangeEndPage />} />
					<Route path="routers/:routerId/cancel-end" element={<CancelEndPage />} />
					<Route path="routers/:routerId/change-plan" element={<ChangePlanPage />} />
					<Route path="routers/:routerId/cancel-start" element={<CancelStartPage />} />
					<Route path="routers/:routerId/change-password" element={<ChangePasswordPage />} />
					<Route path="templates" element={<TemplatesPage />} />
					<Route path="templates/:templateId" element={<TemplatePage />} />
					<Route path="scripts" element={<ScriptsPage />} />
				</>,
			),
		)
		return <RouterProvider router={router} />
	}
}

const Logo = styled.img`
	height: 40px;
	margin-top: -10px;
	margin-bottom: -10px;
	filter: brightness(0) invert(1);
	opacity: 0.7;
`
